import { render, staticRenderFns } from "./preRegistListPage.vue?vue&type=template&id=765dfacc&scoped=true&"
import script from "./preRegistListPage.vue?vue&type=script&lang=js&"
export * from "./preRegistListPage.vue?vue&type=script&lang=js&"
import style0 from "./preRegistListPage.vue?vue&type=style&index=0&id=765dfacc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765dfacc",
  null
  
)

export default component.exports